import React, { useState } from 'react';
import { updateAdminConfig } from '../../utils/api';

const Allocations = ({ config, loadConfig, flash }) => {
  const [alloc, setAlloc] = useState({ payoutPercent: config.payoutPercent, teamIncomePercent: config.teamIncomePercent, adminPercent: config.adminPercent, royaltyPercent: config.royaltyPercent, buyBurnPercent: config.buyBurnPercent });
  const total = (alloc.payoutPercent||0) + (alloc.teamIncomePercent||0) + (alloc.adminPercent||0) + (alloc.royaltyPercent||0) + (alloc.buyBurnPercent||0);
  const BC = config.baseCurrency || 'USDT';

  const save = async () => {
    if (total !== 100) { flash(`Must total 100%. Got ${total}%`, 'error'); return; }
    try { await updateAdminConfig(alloc); flash('Saved'); loadConfig(); } catch (e) { flash(e.response?.data?.error || 'Failed', 'error'); }
  };

  return (
    <div className="fade-in">
      <h2 className="adm-title">Purchase Allocation</h2>
      <p className="adm-hint">Must total 100%.</p>
      <div className="adm-alloc-grid">
        {[['payoutPercent','Payout to Buyer','Tokens minted'],['teamIncomePercent','Team Income',`${BC} to upline`],['adminPercent','Admin Pool','Tokens to admin'],['royaltyPercent','Royalty',`${BC} to royalty`],['buyBurnPercent','Buy Burn','Deflationary']].map(([k,l,d])=>(
          <div key={k} className="card adm-alloc-card">
            <div className="adm-alloc-hdr"><span>{l}</span><div className="adm-alloc-input"><input type="number" value={alloc[k]??''} onChange={e=>setAlloc({...alloc,[k]:parseFloat(e.target.value)||0})} className="input input-sm adm-alloc-num"/><span className="text-3">%</span></div></div>
            <p className="adm-alloc-desc">{d}</p>
          </div>
        ))}
      </div>
      <div className="adm-alloc-footer">
        <span className={`adm-alloc-total mono ${total===100?'text-green':'text-red'}`}>Total: {total}%</span>
        <button className="btn btn-primary" onClick={save}>Save</button>
      </div>
    </div>
  );
};

export default Allocations;